import { render, staticRenderFns } from "./CopyEditor.vue?vue&type=template&id=19912fce&scoped=true&"
import script from "./CopyEditor.vue?vue&type=script&lang=js&"
export * from "./CopyEditor.vue?vue&type=script&lang=js&"
import style0 from "./CopyEditor.vue?vue&type=style&index=0&id=19912fce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19912fce",
  null
  
)

export default component.exports